import {createRouter, createWebHistory} from 'vue-router'
import Dashboard from '@/views/Dashboard.vue'
import Login from '@/views/Login.vue'
import {useAuthStore} from '@/stores/auth'
import {useLoading} from "@/composables/useLoading.ts";

const {startLoading} = useLoading();

const routes = [
    {path: '/login', component: Login, meta: {requiresAuth: false, isShowHeader: false, title: 'Đăng nhập'}},
    {path: '/', component: Dashboard, meta: {requiresAuth: true, isShowHeader: true, title: 'Trang chủ'}},
    {
        path: '/vong-quay-may-man',
        component: () => import('@/views/VongQuay.vue'),
        meta: {requiresAuth: true, isShowHeader: true}
    },
    {
        path: '/ghep-o-bi-an',
        component: () => import('@/views/Puzzle.vue'),
        meta: {requiresAuth: true, isShowHeader: true}
    },
    {
        path: '/ghep-o-bi-an/lich-su',
        component: () => import('@/views/PuzzleHistory.vue'),
        meta: {requiresAuth: true, isShowHeader: true, title: 'Lịch sử mở mảnh ghép'}
    },
    {
        path: '/profile',
        component: () => import('@/views/Profile.vue'),
        meta: {requiresAuth: true, isShowHeader: true, title: 'Thông tin tài khoản'}
    },
    {
        path: '/the-le-chuong-trinh',
        component: () => import('@/views/TheLe.vue'),
        meta: {requiresAuth: false, isShowHeader: true}
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@/views/NotFound.vue'),
        meta: {
            requiresAuth: false,
            isShowHeader: true,
            title: '404 NOT FOUND'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(async (to, _from, next) => {
    startLoading();

    const auth = useAuthStore()

    if (!auth.initialized && to.meta.requiresAuth == true) {
        // Nếu đang ở trang login hoặc OTP, không cần initialize
        if (to.path === '/login') {
            try {
                await auth.initialize()
            } catch (error: any) {
                if (error.response?.status === 401) {
                    auth.isAuthenticated = false
                }
            }
        } else {
            try {
                await auth.initialize()
            } catch (error) {
                try {
                    await auth.refreshToken()
                } catch {
                    auth.isAuthenticated = false
                    await auth.logout()
                }
            }
        }

        auth.initialized = true
    }

    const requiresAuth = to.meta.requiresAuth !== false

    // TRƯỜNG HỢP 1: Người dùng chưa đăng nhập
    if (!auth.isAuthenticated) {
        // Chuyển hướng mọi trang khác về /login
        if (requiresAuth) return next('/login')
    }
    // TRƯỜNG HỢP 2: Người dùng đã đăng nhập
    else {
        // Nếu đã đăng nhập nhưng vẫn truy cập các trang login, chuyển về trang chủ
        if (to.path.startsWith('/login')) {
            return next('/')
        }

        // Nếu truy cập trang chủ, cho phép
        if (to.path === '/') {
            return next()
        }

        if (!requiresAuth && to.path.startsWith('/login')) return next('/')
    }

    next()
})

export default router
